/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { StyleSheet } from 'react-native';
import { pd, getTextStyle } from '@airasia-phoenix/react-native/utils/utils';
import { ContentCardOrientation } from '@airasia-phoenix/react-native/widgets/HorizontalContentCardView/ContentDetailsView';
import {
  ContentCardViewStyle,
  ContentCardViewProps,
} from '@airasia-phoenix/react-native/widgets/ContentCardView';
import { FeaturedDestination, LocalizedString } from '../../models';

export const getLocalizedText = (
  languageId: string,
  data?: LocalizedString,
) => {
  if (!data) return '';
  return data[languageId] ?? data['en-gb'] ?? '';
};

export const createCardProps = (
  item: FeaturedDestination,
  languageId: string,
): ContentCardViewProps => {
  return {
    imageHeight: 150,
    imageWidth: 150,
    image: {
      url: item.image,
    },
    supportingInfo: {
      supportingIcon: { icon: pd.icon.main.communication.location_on },
      supportingText: item.text ? getLocalizedText(languageId, item.text) : '',
    },
    contentDetailsPropsValues: {
      width: ContentCardViewStyle.LARGE,
      imageWidth: ContentCardViewStyle.LARGE,
      orientation: ContentCardOrientation.HORIZONTAL,
      primaryText: item.tagLine
        ? getLocalizedText(languageId, item.tagLine)
        : '',
      primaryTextStyle: StyleSheet.flatten([
        getTextStyle(pd.sys.typescale.heading_4, pd.sys.colour.content_primary),
        {
          marginLeft: -pd.ref.space.spacing30.px,
          marginTop: pd.ref.space.spacing20.px,
        },
      ]),
    },
  };
};
